<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12 lg4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-bell</v-icon>
              Notificações
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg8>
          <v-layout row wrap justify-end>
            <v-btn round depressed large color="success" dark
              v-modal-trigger="'showNewNotification'">
              NOVA NOTIFICAÇÃO
              <v-icon small right>fal fa-plus-circle</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <empty-alert :icon="'bell'" :color="'orange accent-4'" v-if="!notifications.length">
      <div slot="content">
        <p><strong>Nenhuma notificação enviada.</strong></p>
      </div>
    </empty-alert>

    <v-flex xs12 class="section-box" v-if="notifications.length">
      <v-data-table
        width="100%"
        :headers="headers"
        :items="notifications"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            {{ props.item.title }}
          </td>
          <td>{{ props.item.message }}</td>
          <td>
            {{ props.item.url }}
          </td>
          <td>
            <v-tooltip bottom>
              <span slot="activator">{{ props.item.sent_at | moment('from', 'now') }}</span>
              <span>{{ props.item.sent_at | moment('DD/MM/Y, HH:mm') }}</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="info" outline icon="fal fa-users">
            Nenhuma notificação encontrado.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhuma notificação encontrado.
          </div>
        </template>
      </v-data-table>
    </v-flex>
    <new-notification></new-notification>
  </v-layout>
</template>

<script>
// import router from '@/router'
import axios from 'axios'
import AdminNotificationsNew from '@/components/admin/notifications/AdminNotificationsNew'
import EventBus from '@/event-bus'

export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Título', value: 'title' },
      { text: 'Mensagem', value: 'message' },
      { text: 'URL', value: 'url' },
      { text: 'Data de Envio', value: 'sent_at' }
    ],
    notifications: []
  }),

  methods: {
    loadNotifications () {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      axios.get(`${API.notifications}?all_users=true`).then(response => {
        this.notifications = response.data.notifications
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadNotifications')
  },

  created () {
    this.loadNotifications()
    EventBus.$on('loadNotifications', this.loadNotifications)
  },

  components: {
    'new-notification': AdminNotificationsNew
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminNotifications.vue